import { moutonPng } from '../assets/images';

function Mouton() {
  return (
    <div>
      <div
        className="hero h-[18rem] bg-cover bg-no-repeat"
        style={{
          backgroundImage: `url(${moutonPng})`,
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay bg-opacity-60"></div>
        <div className="hero-content text-neutral-content text-center">
          <h1 className="mb-5 text-5xl text-white font-bold">
            Les Meilleures Pratiques pour le Soin
          </h1>
        </div>
      </div>
      <div className="px-6 lg:px-32 text-justify"> {/* Responsive padding */}
        <h1 className="text-4xl bg-black text-white p-4 text-center font-bold my-10">
          Le soin, la santé et le bien-être des moutons.
        </h1>
        <div className="text-gray-700 text-xl gap-8 leading-10 my-20">
          <p>
            Malheureusement, les moutons souffrent souvent de parasites internes ainsi que d’autres maladies. Les éleveurs doivent souvent vermifuger leurs moutons (prenez conseil auprès de votre vétérinaire). Dans les magasins spécialisés, vous pouvez trouver des produits vermifuges de différents types (comprimés, pulvérisateurs, injections, pâtes, etc.). Nous devons également vacciner nos moutons une fois par an (contre la boulimie, le clostridium et d’autres maladies), toujours après avoir consulté le vétérinaire. Les moutons aux besoins spécifiques peuvent nécessiter une vaccination plus fréquente.
          </p>
          <p>
            De plus, nous devons régulièrement nous assurer du bien-être de nos moutons. La diarrhée est un symptôme courant d’une maladie ovine. Un mouton avec les yeux qui larmoient, le nez qui coule, qui s’isole du troupeau, qui ne rumine pas, qui ne boit pas, qui dort toute la journée et/ou qui n’est pas capable de se tenir debout montre des signes que quelque chose ne va pas. Dans tous les cas, nous devons toujours avoir sous la main le numéro de téléphone du vétérinaire local. Dans de nombreuses situations, le vétérinaire va demander la température rectale du mouton, avant de décider de venir sur place ou non. La température rectale normale d’un mouton se situe entre 38,3°C et 39,9°C.
          </p>
          <p>
            Dans de nombreux pays, il est très commun pour un éleveur de moutons de leur couper la queue pour éviter des problèmes d’hygiène (les longues queues finissent par être recouvertes de fumier et attirent les mouches). Cependant, vous devriez contacter votre vétérinaire local pour des instructions plus précises. Les éleveurs de moutons taillent également les sabots (avec une pince coupe-onglons) pour éviter les infections (pourriture du sabot). Les sabots doivent être vérifiés toutes les deux semaines mais la taille doit être effectuée moins souvent que pour les chèvres (les chèvres ont besoin d’une taille généralement tous les deux mois, alors que les sabots des moutons peuvent être taillés tous les 3 ou 4 mois, mais nous devons faire plus attention en conditions humides). Enfin, de nombreux fermiers tondent la laine au moins une fois par an, de préférence avant les chaleurs estivales. Quelques races spécifiques ont besoin de deux ou trois tontes par an.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Mouton;
